import React, { useState ,useEffect} from "react";

import {
Link,
useNavigate
} from "react-router-dom";
import ReactQuill from 'react-quill';

import {HeadBg,MidBg,FootBg,NewMidBg,FstLogo,SiteLogoDark,blogBg,blogImage} from '../ImagesIcons.js';




  import Header from "../includes/Header";
// import Sidebar from "../includes/Sidebar";
// import Navbar from "../includes/Navbar";
// import Pagetitle from "../includes/Pagetitle";


// import Footer from "../includes/Footer";

import {UrlSplitter,SetNotificationAfterName,Notifyalert,frontUrl , Url,Whybg,Banner,Vision,Visionfirst,Visionsecond,Visionthird,Visionfour, Servicefirst,Servicesecond,Servicethird,Servicefour,Servicefive,Servicesix,Whyfirst,Whysecond,Whythird,Whyfour,Whyfive,Whysix, SiteLogo,redirectfrontPage,Redirectdashboard,Redirectlogin ,containerStart , containerEnd , AkuserId,AKcountsupdated} from '../Frontapi.js';




import Signup from "../auth/Register"


import Dashboard from "../pages/Dashboard"


import SiteHeader from "../includes/SiteHeader";
import SiteFooter from "../includes/SiteFooter";


import Footer from "../includes/Footer";



const Blog = () => {
const navigate = useNavigate();


const blogurl = UrlSplitter(2);

 

const [blogdetail,setBlogdetail]=useState([]);


const [contactname,setcontactName]=useState('');

const [contactemail,setcontactEmail]=useState('');
const [message,setMessage]=useState('');



const [offlemail,setOfflemail]=useState('');
const [offlphone,setOfflphone]=useState('');
const [offlmobile,setOfflmobile]=useState('');

const [offladdress,setOffladdress]=useState('');




const GetBlog = async (value ) => {
//showLoader(true);

  

 
      var postdata={ url : blogurl};

        const response = await fetch(Url+"getblog", {
        method: "POST",
         headers: {
          "Content-Type": "application/json",
        } ,
        body: JSON.stringify({postdata }),
         
      }).then((response) => response.json())
         .then((data) => { 
          if (data.success) { 

 


var postdatavalues= data.data;
 
  
   
    setBlogdetail(postdatavalues);
 
 

    
          } else{
                 
          }

           
       })


 
  };




const Getsettings = async (e) => {

try{


var postdata={getdata:1};

const response = await fetch(Url+"get-front-settings", {
method: "POST",
headers: {
"Content-Type": "application/json",
} ,
body: JSON.stringify({ postdata }),
}).then((response) => response.json())
.then((data) => {
if (data.success) {



var settingsdata=data.data;
setOfflemail(settingsdata.email );
setOfflphone(settingsdata.phone );
setOfflmobile(settingsdata.mobile );


setOffladdress(settingsdata.address+ ', '+settingsdata.city );





} else{
// ;
}


})



} catch (error) {

console.log(error)

}

}






const SubmitContactus = async (e) => {
e.preventDefault();

try {





var postdata={contactemail:contactemail, contactmessage:message , contactname : contactname };

/***Check Required***/
var required_fields= document.getElementsByClassName('MustContactEnterField')
if(document.getElementsByClassName('notify-input-text')[0]){
document.getElementsByClassName('notify-input-text')[0].remove('notify-input-missing');
}
var error=0;
Array.prototype.forEach.call(required_fields, function(el) {
el.classList.remove('notify-input-missing');
el.classList.add('mb-25');
if(el.value === '' && error == 0){
var inputname = el.name.charAt(0).toUpperCase() + el.name.slice(1);
el.classList.add('notify-input-missing');
el.classList.remove('mb-25');
error=1;



SetNotificationAfterName(el.name, inputname + ' required')
}
});
/***Check Required***/

if(error === 1){
return false
}


const response = await fetch(Url+"create-inquiry", {
method: "POST",
headers: {
"Content-Type": "application/json"
} ,
body:JSON.stringify({postdata})

}).then((response) => response.json())
.then((data) => {
if (data.success) {
Notifyalert('success', data.message)

document.getElementById("ContactForm").reset();
setMessage('')
} else{
// ;
}


})

} catch (error) {
console.log(error)
}
};



const ScrollToSec = async (id) =>
{
var element = document.getElementById(id);
element?.scrollIntoView({
behavior: 'smooth'
});
}


useEffect(() => {

Getsettings();

GetBlog();



}, []);


return (

<div id="app">
    <div className=" full-section">
        <div className=" full-section  bg-white">

            
              <Header pageInfo="Blogdetail" />



            <SiteHeader />



        
            <div className="container py-3 py-md-4">
                <section className="detail-content">
                    <div className="deatil-heading">
                        <h1>{blogdetail.title}</h1>
                        <hr/>
                        <div className="d-flex flex-wrap justify-content-start align-items-center">
                            <div className="me-3"><i className="fa-solid fa-user fs-6 service-icon"></i><span
                                    className="ms-2">{blogdetail.createdby}</span></div>
                            <div className="me-3"><i className="fa-solid fa-calendar-days fs-6 service-icon"></i><span
                                    className="ms-2">{blogdetail.created}</span></div>
                           
                        </div>
                    </div>

                    <div className="d-flex justify-content-center col-12 pt-3">
                        <div className=" col-8">
                                <img className="img-fluid w-100" src={blogdetail.image} />
                        </div>
                    </div>
 
                    <div  dangerouslySetInnerHTML={{__html:  blogdetail.description}} >
                </div>

                </section>
            </div>

 
 







        </div>
   <SiteFooter />
    </div>

</div>

);
};
export default Blog;